/**
 *
 * @param {*} time 秒
 * @param {*} format
 * @returns
 */
export function formatTime(time, format = 'hh:mm:ss') {
  if (!time) {
    time = 0
  }
  const dict = {
    hh: `${Math.floor(time / 3600) + 100}`.substr(1),
    mm: `${Math.floor((time / 60) % 60) + 100}`.substr(1),
    ss: `${Math.floor(time % 60) + 100}`.substr(1)
  }
  return format.replace(/(hh?|mm?|ss?|SSS?)/g, function () {
    return dict[arguments[0]]
  })
}